import {Component, Inject, ChangeDetectionStrategy} from '@angular/core';

import {FormsModule} from '@angular/forms';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatButtonModule} from '@angular/material/button';
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from '@angular/material/dialog';

@Component({
    selector: 'ukata-common-modals',
    imports: [],
    template: ``,
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './common-modals.component.scss'
})
export class CommonModalsComponent {
}

@Component({
    selector: 'single-input-modal',
    imports: [MatFormFieldModule, FormsModule, MatInputModule, MatButtonModule, MatDialogModule],
    template: `
    @if (data.title) {
      <h2 mat-dialog-title>{{ data.title }}</h2>
    }
    <div mat-dialog-content>
      <mat-form-field appearance="fill" style="width: 100%">
        <mat-label>{{ data.label }}</mat-label>
        <input matInput required [(ngModel)]="value" />
      </mat-form-field>
    </div>
    <div mat-dialog-actions align="end">
      <button mat-button (click)="dialogRef.close()">Cancel</button>
      <button mat-flat-button color="primary" (click)="dialogRef.close(value)">
        OK
      </button>
    </div>
    `,
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './common-modals.component.scss'
})
export class SingleInputModalComponent {
  value: string = '';

  constructor(
    public dialogRef: MatDialogRef<SingleInputModalComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      title?: string;
      label: string;
    },
  ) {
  }

  getValue() {
    return this.value;
  }
}
